import { GNS } from '../core/GNS.js';

/**
 * GNS.DisplayObject
 * 
 * DOM要素をオブジェクト指向で扱うためのラッパークラス
 * jQueryライクなメソッドを提供
 * 
 * 主要メソッド:
 * - init(element): 初期化
 * - addClass(className): クラス追加
 * - removeClass(className): クラス削除
 * - hasClass(className): クラス存在チェック
 * - addEvent(type, callback): イベント追加
 * - removeEvent(type, callback): イベント削除
 * - getPosition(parent): 位置取得
 * - getRect(parent): 矩形取得
 * 
 * プロパティ:
 * - element: 実際のDOM要素
 * - classes: クラス名の配列
 */
GNS.DisplayObject = function (a) {
    var b = a.create(a.EventDispatcher);
    return b.init = function (c) {
        b._super.init.call(this), null != c && ("string" == typeof c && (c = a.DOM.getElement(c)), this.element = c),
            this.classes = [], this.element && String(this.element.className)
                .length > 0 && this.element.className.split && (this.classes = this.element.className.split(" "))
    }, b.onLoad = function (a, b) {
        var c = this.element;
        "onreadystatechange" in c ? c.onreadystatechange = function (d) {
            ("loaded" === c.readyState || "complete" === c.readyState) && a(), "uninitialized" === c.readyState &&
                null != b && b()
        } : (c.onload = a, null != b && (c.onerror = b))
    }, b.appendChild = function (a) {
        a.appendChild(this.element)
    }, b.removeChild = function (a) {
        a.removeChild(this.element)
    }, b.getPosition = function (b) {
        return a.DOM.getPosition(this.element, b)
    }, b.getRect = function (b) {
        return a.DOM.getRect(this.element, b)
    }, b.addEvent = function (b, c) {
        a.DOM.addEvent(this.element, b, c)
    }, b.removeEvent = function (b, c) {
        a.DOM.removeEvent(this.element, b, c)
    }, b.hasClass = function (a) {
        if (this.element) {
            var b = this.classes.join(" "),
                c = -1 != b.indexOf(a);
            if (c)
                for (var d in this.classes)
                    if (this.classes[d] == a) return !0;
            return !1
        }
    }, b.addClass = function (a) {
        if (this.element && !this.hasClass(a)) {
            this.classes.push(a);
            var b = this.classes.join(" ");
            this.element.className = b
        }
    }, b.removeClass = function (a) {
        if (this.element) {
            var b = this.classes.join(" "),
                c = -1 != b.indexOf(a);
            if (c) {
                for (var d in this.classes)
                    if (this.classes[d] == a) {
                        this.classes.splice(d, 1);
                        break
                    } b = this.classes.join(" "), this.element.className = b
            }
        }
    }, b._self
}(GNS);
